import { render } from "./Accounts.vue?vue&type=template&id=5d701bdc&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"

import "./Accounts.vue?vue&type=style&index=0&id=5d701bdc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d701bdc"]])

export default __exports__